import { useAuthStore } from '@/stores/auth.store';
import { refresh } from '@/api/auth.service';

const refreshLock = 'token-refresh-lock';

export const attemptTokenRefresh = async (): Promise<string> => {
  const authStore = useAuthStore();

  const refreshToken = localStorage.getItem('refreshToken');

  if (!refreshToken) {
    throw new Error('Session expired');
  }

  const payload = refreshToken.split('.')[1];
  if (!payload) throw new Error('Malformed refresh token: missing payload segment');
  const refreshTokenDetails = JSON.parse(atob(payload));

  if (refreshTokenDetails.exp < Date.now() / 1000) {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    authStore.clearStore();

    throw new Error('Session expired');
  }

  try {
    // Use Navigator.locks to ensure only one refresh operation at a time
    return await navigator.locks.request(refreshLock, async () => {
      const refreshResponse = await refresh(refreshToken);
      const { accessToken: newAccessToken, refreshToken: newRefreshToken } =
        refreshResponse.data.data;

      authStore.setAccessToken(newAccessToken);
      authStore.setRefreshToken(newRefreshToken);

      return newAccessToken;
    });
  } catch {
    throw new Error('Session expired');
  }
};
